export default {
    'Loading...': 'Загрузка...',
    'Online registration is disabled': 'Онлайн-записи отключены',
    'Select service': 'Выберите услугу',
    'Confirm': 'Подтвердить',
    'Enter the phone number provided by registering at the clinic': 'Введите номер телефона, указанный при регистрации в клинике',
    'Enter Phone Number': 'Введите номер телефона',
    'Send': 'Отправить',
    'Verification Code': 'Код подтверждения',
    'verification-message': 'Сообщение с кодом подтверждения отправлено на {phone}. Введите код для продолжения.',
    'Invalid code': 'Неверный код',
    'Wrong Number?': 'Неправильный номер?',
    'Verifying...': 'Проверка...',
    'Verify': 'Подтвердить',
    'Name': 'Имя',
    'Enter Name': 'Введите имя',
    'Surname': 'Фамилия',
    'Enter Surname': 'Введите фамилию',
    'Saving...': 'Сохранение...',
    'Save': 'Сохранить',
    'Thank you for the reservation. We will contact you shortly and confirm the appointment.': 'Спасибо за бронирование.<br> Мы свяжемся с вами в ближайшее время и подтвердим вашу запись на приём.',
    'No free time available': 'Нет свободного времени в этот день',
    'Back to Home': 'Вернуться на Главную',
    'No upcoming appointments': 'Нет предстоящих приёмов',
    'Select clinic': 'Выберите клинику',
    'You are registered in these clinics': 'Вы зарегистрированы в следующих клиниках',
    'No clinics': 'Нет клиник',
    'Home': 'Главная',
    'Appointments': 'Записи на приём',
    'Contacts': 'Контакты',
    'Switch clinic': 'Сменить клинику',
    'Logout': 'Выйти',
    'Log in to your personal cabinet': 'Войдите в личный кабинет',
    'Log In': 'Войти',
    'Book an appointment': 'Записаться на приём',
    'Upcoming appointments': 'Предстоящие встречи',
    'Show all': 'Показать все',
    'Not confirmed': 'Не подтверждён',
    'Confirmed': 'Подтверждён',
    'Cancelled': 'Отменен',
    'Completed': 'Завершен',
    'New': 'Новый',
    'Not shown': 'Не явился',
    'Started': 'На приёме',

    'Please, enter valid phone number': 'Введен неверный формат номера телефона. Пожалуйста, попробуйте снова',
    'Enter code from SMS': 'Введите код из SMS',

    'Enter answer here': 'Введите ответ',
    'Previous': 'Предыдущий',
    'Submit': 'Отправить',
    'Next': 'Следующий',
    'Thank you': 'Спасибо вам',
    'for your feedback!': 'за отзыв!',
    'Give feedback': 'Оставить отзыв',

    'Checking': 'Проверка',
    'Error': 'Ошибка',

    'Select a specialist': 'Выберите специалиста',
    'No specialists available': 'Нет доступных стоматологов',
    'Select a day': 'Выберите день',
    'Select a time': 'Выберите время',
    'Input data to register': 'Введите данные для регистрации',
    'Enter your name': 'Введите ваше имя',
    'Enter your phone number': 'Введите ваш номер телефона',
    'Phone number': 'Номер телефона',

    'Closed': 'Закрыто',
    'Change': 'Изменить',

    'Clinic not found': 'Клиника не найдена',
    'Check the link or contact the clinic': 'Проверьте ссылку или свяжитесь с клиникой',
    'Please call the clinic to book an appointment': 'Позвоните в клинику, чтобы записаться на приём',
    'About the clinic': 'О клинике',
    'Open now': 'Открыто',
    'Closed now': 'Закрыто',
    'Back': 'Назад',
    'Step {current} of {total}': 'Шаг {current} из {total}',
    'Select date and time': 'Выберите дату и время',
    'Your phone number': 'Ваш номер телефона',
    'Check the details': 'Проверьте данные',
    'Appointment booked': 'Вы записаны',
    'No services available': 'Нет доступных услуг',
    'Try another service or call the clinic': 'Выберите другую услугу или позвоните в клинику',
    'Week': 'Неделя',
    'Month': 'Месяц',
    'Pick another day in the calendar above': 'Выберите другой день в календаре выше',
    'Morning': 'Утро',
    'Afternoon': 'День',
    'Evening': 'Вечер',
    'We will send a confirmation code to this number': 'На этот номер придёт код подтверждения',
    'Your details are used only for this appointment': 'Данные используются только для этой записи',
    'Verification failed, try again!': 'Не удалось подтвердить код, попробуйте ещё раз',
    'Resend code': 'Отправить код ещё раз',
    'Resend in {seconds} s': 'Отправить повторно через {seconds} с',
    'Specialist': 'Специалист',
    'Service': 'Услуга',
    'Address': 'Адрес',
    'Clinic phone': 'Телефон клиники',
    'Could not book the appointment, please try again': 'Не удалось создать запись, попробуйте ещё раз',
    'We will contact you shortly to confirm the appointment': 'Мы свяжемся с вами в ближайшее время и подтвердим запись',
    'Website': 'Сайт',
    'Email': 'Почта',
    'Opening hours': 'Часы работы',
    'Today': 'Сегодня',
    'Tomorrow': 'Завтра',
    'Nearest available time': 'Ближайшее свободное время',
    'All specialists': 'Все специалисты',
    'No free time in the next days': 'Нет времени в ближайшие дни',
    'Search by name': 'Поиск по имени',
    'Nobody found': 'Никого не нашлось',
    'Choose another service': 'Выбрать другую услугу',
    'Could not load the time': 'Не удалось загрузить время',
    'Check the connection and try again': 'Проверьте соединение и попробуйте снова',
    'Try again': 'Попробовать снова',
    'Thank you for the reservation': 'Спасибо за бронирование',
    'Go to your cabinet': 'Перейти в кабинет',
}
